import React, { useState } from "react";
import axios from "axios";
import "./Weather.css";
import FormatDate from "./FormateDate";
import WeatherIcon from "./WeatherIcon";
import TemperatureConvert from "./TemperatureConvert";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [weatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);
  function handleResponse(response) {
    console.log(response);
    setWeatherData({
      ready: true,
      temperature: Math.round(response.data.temperature.current),
      description: response.data.condition.description,
      wind: response.data.wind.speed,
      humidity: response.data.temperature.humidity,
      city: response.data.city,
      country: response.data.country,
      date: new Date(response.data.time * 1000),
      icon: response.data.condition.icon,
      coordinates: response.data.coordinates,
    });
  }
  function search() {
    const apiKey = "f437a67519o9abbba5b8c7t03f34cda0";
    let apiUrl = `https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }
  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }

  if (weatherData.ready) {
    return (
      <div className="Weather">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-9">
              <input
                type="search"
                placeholder="Enter a city..."
                className="form-control"
                autoFocus="on"
                onChange={handleCityChange}
              />
            </div>
            <div className="col-3">
              <input type="submit" value="Search" className="btn btn-primary" />
            </div>
          </div>
        </form>

        <h1>
          {weatherData.city},{weatherData.country}
        </h1>

        <ul>
          <li>
            <FormatDate date={weatherData.date} />
          </li>
          <li>{weatherData.description}</li>
        </ul>
        <div className="row mt-3">
          <div className="col-6 temperature-section">
            <WeatherIcon code={weatherData.icon} className="icon-img" />

            <TemperatureConvert celsius={weatherData.temperature} />
          </div>
        </div>
        <div className="humidity-wind">
          <ul>
            <li>Humidity: {weatherData.humidity}%</li>
            <li>Wind: {weatherData.wind}km/hr</li>
          </ul>
        </div>
        <div className="forecast-section">
          <WeatherForecast coordinates={weatherData.coordinates} />
        </div>
      </div>
    );
  } else {
    search();
    return "Loading...";
  }
}
